<template>
    <CardUploadFiles
        :titleCard="'Precisamos verificar o baú do seu veículo (parte interna)'"
        :cardDescription="'vehicle_trunk'"
        :textCard="'Baú do veículo'"
        :srcExampleImage="ImageFrontVehicle"
        :nextRoute="'VehicleSide'"
        :previewScreen="'PreviewVehicleFiles'"
    />
</template>
<script>
    import CardUploadFiles from '../../components/CardUploadFiles.vue'
    import ImageFrontVehicle from '../../../../public/images/trunk.svg'
   
    export default {
        components: {
            CardUploadFiles
        },
        setup() {
            return {          
                ImageFrontVehicle
            };
        }, 
    }
</script>